import * as t from './actionTypes';

import common from '../../common';

export function loadUsers() {
    return async (dispatch, getState) => {
        const resp = await common.managementApiClient.get(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/users`)
        dispatch({
            type: t.LOAD_USERS,
            payload: resp.data
        })
    };
}
export function setSelectedUser(id) {
    return function (dispatch) {
        dispatch({
            type: t.SET_SELECTED_USER,
            payload: id
        });
    };
}
